import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import API from "../Service/Baseservice";
import CalendarIcon from "../../Assets/img/calendar.png";
import CharIcon from "../../Assets/img/word.png";
import UploadIcon from "../../Assets/img/upload.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import BlogPreview from "./Blogpreview";
import CreatableSelect from "react-select/creatable";

const BlogEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const blog = location.state?.blog;
    console.log("blog", blog);
    const page = location.state?.page || 1;
    const [formData, setFormData] = useState({
        language_id: blog?.language_id || 1,
        author_name: blog?.author_name || "",
        heading: blog?.heading || "",
        description: blog?.description || "",
        blog_date: blog?.blog_date?.split(" ")[0] || "",
        blog_image: blog?.blog_image || "",
        blogseo_id: blog?.blogseo_id || "",
        blog_tag_id: [],
        status: blog?.status || "active",
        createdBy: blog?.createdBy || 1,
        updatedBy: blog?.updatedBy || 1,
        active: 1,
    });

    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "info",
    });

    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(blog?.blog_image || null);
    const [uploadedUrl, setUploadedUrl] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPreviewBlog, setShowPreviewBlog] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const MAX_CHARS = 10000;
    const [lastValidDescription, setLastValidDescription] = useState(
        blog?.description || ""
    );

    // --- Tag Dropdown ---
    const [tagOptions, setTagOptions] = useState([]);
    const [selectedTag, setSelectedTag] = useState([]);
    const [servicesList, setServicesList] = useState([]);
    const [selectedService, setSelectedService] = useState(
        blog?.blogseo_id || ""
    );
    // Fetch Active Tags
    useEffect(() => {
        const payload = {
            language_id: formData.language_id,
            search: "",
            status: "active",
        };

        API.post("blogtag_list/condition", payload)
            .then((res) => {
                const tagArray = res?.data?.data?.data;
                if (Array.isArray(tagArray)) {
                    const formatted = tagArray.map((tag) => ({
                        value: tag.blog_tag_id,
                        label: tag.blogtag.trim(),
                    }));
                    setTagOptions(formatted);


                    let selectedTagIds = [];
                    if (blog?.blog_tag_id) {
                        try {
                            selectedTagIds = JSON.parse(blog.blog_tag_id);
                        } catch {
                            console.warn("Invalid blog_tag_id format:", blog.blog_tag_id);
                        }
                    }

                    if (Array.isArray(selectedTagIds) && selectedTagIds.length > 0) {
                        const existing = formatted.filter((opt) =>
                            selectedTagIds.includes(opt.value)
                        );
                        setSelectedTag(existing);
                        setFormData((prev) => ({
                            ...prev,
                            blog_tag_id: selectedTagIds,
                        }));
                    }
                } else {
                    console.warn("Invalid tag list:", res);
                }
            })
            .catch((err) => console.error("Error fetching blog tags:", err));
    }, [formData.language_id]);



    // Handle change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const getPlainTextLength = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent?.length || 0;
    };

    const handlePreview = () => {
        if (!formData.heading || !formData.description || !formData.blog_date) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all required fields to preview",
                type: "info",
            });
            return;
        }

        setPreviewData({
            ...formData,
            blog_id: "preview",
            blog_image: imagePreview,
        });
        setShowPreviewBlog(true);
    };

    const handleSubmit = () => {
        if (
            !formData.heading ||
            !formData.description ||
            !formData.blog_date ||
            !formData.blog_image ||
            !formData.blog_tag_id ||
            !formData.author_name
        ) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all required fields.",
                type: "info",
            });
            return;
        }

        if (!imageFile) {
            setUploadedUrl(formData.blog_image);
        }

        setIsSubmitting(true);
    };

    // Upload image if new
    useEffect(() => {
        if (isSubmitting && imageFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Image = reader.result;
                const imagePayload = {
                    name: imageFile.name,
                    image: [
                        {
                            name: imageFile.name,
                            type: imageFile.type,
                            size: `${imageFile.size} bytes`,
                            base64: base64Image,
                        },
                    ],
                };

                API.post("imageUpload/add", imagePayload)
                    .then((res) => {
                        const url = res.data?.url;
                        setUploadedUrl(url);
                    })
                    .catch((err) => {
                        console.error("Image upload failed:", err);
                        setPopup({
                            show: true,
                            title: "Error",
                            message: "Image upload failed",
                            type: "error",
                        });
                        setIsSubmitting(false);
                    });
            };
            reader.readAsDataURL(imageFile);
        } else if (isSubmitting) {
            setUploadedUrl(formData.blog_image);
        }
    }, [isSubmitting, imageFile]);

    // Final blog update
    useEffect(() => {
        if (uploadedUrl && isSubmitting) {
            const payload = {
                ...formData,
                blog_id: Number(id),
                language_id: Number(formData.language_id),
                active: formData.active ?? 1,
                blog_image: uploadedUrl || "",
            };

            API.post("blogs_edit/update", payload)
                .then((res) => {
                    setPopup({
                        show: true,
                        title: res.data?.success ? "Success" : "Error",
                        message: res.data?.message || "Blog updated successfully!",
                        type: res.data?.success ? "success" : "error",
                    });
                    // if (res.data?.success) setTimeout(() => navigate("/blog", { state: { page } }), 3500);
                })
                .catch((err) => {
                    console.error("Failed to update blog:", err);
                    setPopup({
                        show: true,
                        title: "Error",
                        message: "An unexpected error occurred",
                        type: "error",
                    });
                })
                .finally(() => setIsSubmitting(false));
        }
    }, [uploadedUrl, isSubmitting]);

    useEffect(() => {
        if (blog?.description) {
            setLastValidDescription(blog.description);
        }
    }, [blog]);
    const fetchServices = () => {
        API.post("blogseo_list/condition", { language_id: formData.language_id })
            .then((res) => {
                const active = (res?.data?.data?.data || [])
                    .filter((x) => x.active === 1 || x.active === "1")
                    .sort((a, b) => Number(a.order_by) - Number(b.order_by));
                setServicesList(active);
            })
            .catch((err) => console.error("Service load error:", err));
    };
    useEffect(() => {
        fetchServices();
    }, [formData.language_id]);
    return (
        <div className="newss-containeradd">
            {/* Header */}
            <div className="blogadd-header">
                <h2 className="services-title1">Edit Blog</h2>
                <div className="header-buttons">
                    <button onClick={handlePreview} className="btn saves-btn">
                        Preview
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="btn saves-btn"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? "Update" : "Update"}
                    </button>
                    <button onClick={() => navigate("/blog", { state: { page } })} className="cancel-btn ">
                        Back
                    </button>
                </div>
            </div>

            {/* Form Wrapper */}
            <div className="blogadd-form-wrapper">
                {/* Left Side */}
                <div className="blogadd-left-card">
                    <div className="upload-section" style={{ textAlign: "left" }}>
                        <label>
                            Upload Image <span className="required">*</span>
                        </label>
                        <div className="edit-upload-box">
                            {imagePreview ? (
                                <img src={imagePreview} alt="Preview" className="preview-img" />
                            ) : (
                                <>
                                    <img src={UploadIcon} alt="Upload" className="upload-icon" />
                                    <p>Click to upload</p>
                                </>
                            )}
                            <input type="file" accept="image/*" onChange={handleImageUpload} />
                        </div>
                    </div>

                    <div className="form-group2">
                        <label>
                            Author Name <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            name="author_name"
                            placeholder="Enter author name"
                            value={formData.author_name}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group2">
                        <label >Language <span className="required">*</span></label>
                        <select
                            name="language_id"
                            value={formData.language_id ?? ""}
                            onChange={handleChange}
                            disabled
                        >
                            <option value="">Select Language</option>
                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>

                    <div className="form-group2">
                        <label>
                            Date <span className="required">*</span>
                        </label>
                        <div className="date-wrapper1">
                            <input
                                type="date"
                                name="blog_date"
                                value={formData.blog_date}
                                onChange={handleChange}
                                onFocus={(e) => e.target.showPicker?.()}
                            />
                            <img
                                src={CalendarIcon}
                                alt="Calendar"
                                className="calendar-blog-icon"
                                onClick={() =>
                                    document.querySelector('input[type="date"]').showPicker?.()
                                }
                            />
                        </div>
                    </div>
                </div>

                {/* Right Side */}
                <div className="blogadd-right-card">
                    <div className="form-group">
                        <label className="description-label">
                            <span className="label-text">
                                Heading <span className="required">*</span>
                            </span>
                            <div className="char-wrapper">
                                <img src={CharIcon} alt="Character count" />
                                <span className="char-count">
                                    {getPlainTextLength(formData.heading)}/100
                                </span>
                            </div>
                        </label>
                        <input
                            type="text"
                            name="heading"
                            placeholder="Enter heading"
                            value={formData.heading}
                            onChange={(e) => {
                                if (e.target.value.length <= 100) {
                                    setFormData({ ...formData, heading: e.target.value });
                                }
                            }}
                        />
                    </div>
                    {/* <div className="form-group">
                        <label className="description-label">Blog Service Name</label>
                            <select
                                value={selectedService}
                                onChange={(e) => {
                                    const value = Number(e.target.value);

                                    setSelectedService(value);

                                    setFormData((prev) => ({
                                        ...prev,
                                        blogseo_id: value,
                                    }));
                                }}
                            >
                                <option value="">Select Service</option>

                                {servicesList.map((service) => (
                                    <option
                                        key={service.blogseo_id}
                                        value={service.blogseo_id}
                                    >
                                        {service.heading}
                                    </option>
                                ))}
                            </select>
                    </div> */}

                    {/* --- Tag Dropdown --- */}
                    <div className="form-group">
                        <label className="description-label">
                            <span className="label-text">
                                Tag <span className="required">*</span>
                            </span>
                        </label>
                        <CreatableSelect
                            isMulti
                            options={tagOptions}
                            value={selectedTag}
                            onChange={(options) => {
                                setSelectedTag(options);
                                setFormData({
                                    ...formData,
                                    blog_tag_id: options.map((opt) => opt.value),
                                });
                            }}
                            placeholder="Select or type to add tag..."
                            isSearchable
                            isClearable
                            menuPortalTarget={document.body}

                            styles={{
                                control: (base) => ({
                                    ...base,
                                    borderColor: "#ccc",
                                    boxShadow: "none",
                                    width: "100%",
                                }),
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                }),
                            }}
                            formatCreateLabel={(inputValue) => `+ Add new tag "${inputValue}"`}
                        />

                    </div>

                    {/* --- Description --- */}
                    <div className="form-group">
                        <label className="description-label">
                            <span className="label-text">
                                Description <span className="required">*</span>
                            </span>
                            <div className="char-wrapper">
                                <img src={CharIcon} alt="Character count" />
                                <span className="char-count">
                                    {getPlainTextLength(formData.description)}/10000
                                </span>
                            </div>
                        </label>

                        <CKEditor
                            editor={ClassicEditor}
                            data={formData.description}

                            onChange={(event, editor) => {
                                const html = editor.getData();

                                // Convert HTML → plain text
                                const div = document.createElement("div");
                                div.innerHTML = html;
                                const text = div.textContent || "";

                                if (text.length <= MAX_CHARS) {
                                    // ✅ Save valid content
                                    setLastValidDescription(html);
                                    setFormData(prev => ({
                                        ...prev,
                                        description: html
                                    }));
                                } else {
                                    // ❌ Block typing by restoring last valid content
                                    editor.setData(lastValidDescription);
                                }
                            }}

                            config={{
                                toolbar: [
                                    "undo", "redo", "|",
                                    "heading", "|",
                                    "bold", "italic", "underline", "|",
                                    "bulletedList", "numberedList",
                                ],
                            }}
                        />


                    </div>
                </div>
            </div>

            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                            <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/blog");
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showPreviewBlog && (
                <BlogPreview
                    previewBlog={previewData}
                    setShowPreviewBlog={setShowPreviewBlog}
                />
            )}
        </div>
    );
};

export default BlogEdit;
